import React from 'react';

import moment from 'moment';

import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import EventIcon from 'APP_ROOT/components/common/eventIcon';
import EventItemMediaIcon from './EventItemMediaIcon';
import { EventItemMediaIcon as LegacyNonImmutableEventItemMediaIcon } from'APP_ROOT/components/pages/dashboard/eventItemMediaIcon';
import {SpeedZoneLabel, SpeedZoneBadge} from 'APP_ROOT/components/common/speedZones/SpeedZoneBadge';
import DriverBadge from 'APP_ROOT/components/common/drivers/DriverBadge';
import IdlingBadge from 'APP_ROOT/components/common/idling/IdlingBadge';
import LocationBadge from 'APP_ROOT/components/common/badges/LocationBadge';
import GeofenceBadge from 'APP_ROOT/components/common/badges/GeofenceBadge';
import PossibleImpactBadge from 'APP_ROOT/components/common/badges/PossibleImpactBadge';
import StreamingBadge from 'APP_ROOT/components/common/badges/StreamingBadge';
import LowBatteryBadge from 'APP_ROOT/components/common/badges/LowBatteryBadge';

export default class EventItem extends React.PureComponent {

    state = {
        tooltip: undefined
    }

    componentDidMount() {
        const { event } = this.props;
        if (!this.props.renderForDashboard) { // RAV-3581 - Location details can be wrong for a live dashboard for some unknown reason. Since the current production app's dashboard does not show location details on events, I am disabling location details on Dashboard until there is time to investigate.
            if (event.geoStamp) {
                this.locationRequestCanceled = false;
                RavenUtil.getLocationFeatures(event.geoStamp.lon, event.geoStamp.lat,
                    (info) => {
                        if(this.locationRequestCanceled) return;
                        this.setState({
                            tooltip: RavenUtil.getLocationName(info)
                        });
                    },
                    (error) => {
                        if(this.locationRequestCanceled) return;
                        const tooltip = (event.geoStamp.lon && event.geoStamp.lat)
                            ? `${event.geoStamp.lon} ${event.geoStamp.lat}`
                            : strings.unknown;
                        this.setState({ tooltip });
                    }
                );
            }
        }
    }

    componentWillUnmount() {
        this.cancelLocationRequest();
    }

    cancelLocationRequest = () => {
        this.locationRequestCanceled = true;
    }

    render() {
        const {
            ravenUuid,
            card,
            renderForDashboard,
            event,
            index,
            selected,
            selectEvent,
            referenceTime, /* used to decide whether we need to include date in time string */
            unitOfMeasure,
            mediaRequestType
        } = this.props;
        let currentLocale = this.props.currentLocale ? this.props.currentLocale : getCurrentLocale(); // load this once, if needed (trying to reduce the amount of calls to this function)
        const className = ['event-item'];
        if (selected) className.push('selected')
        className.push(event.type)
        if (event.parked) {
            className.push("parked");
        }
        if (event.speeding) {
            className.push("speeding");
        }
        if (event.idling) {
            className.push("idling");
        }
        if (event.clustered) {
            className.push("clustered");
        }

        let eventName = document.getEventName(event);
        let eventLabelComponent;
        let eventBadgeComponent;
        let renderFlexboxEvent = false; // renderFlexboxEvent is a way to mitigate risks while moving to a more versatile LI DOM structure
        let durationString = null;
        switch (event.type) {
            case 'EVENT_SPEEDING_STARTED':
            case 'EVENT_SPEEDING_STOPPED':
            case 'EVENT_SPEEDING_MERGED':

                if (event.eventParams && event.eventParams.EVENT_PARAM_SPEED_LIMIT_SOURCE && String(event.eventParams.EVENT_PARAM_SPEED_LIMIT_SOURCE) === "1") {
                    eventName = "AI - " + eventName;
                }

                renderFlexboxEvent = true;
                const speedZone = RavenUtil.getSpeedzoneForEvent(card, event);
                if (speedZone) {
                    const speedLimit = speedZone.speedLimit;
                    const maxSpeed = speedZone.maxSpeed;
                    const startTime = speedZone.startTime;
                    const startDate = new Date(startTime);
                    const endTime = speedZone.endTime;
                    const endDate = new Date(endTime);

                    if (!speedLimit) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid speedLimit", speedZone);
                    } else if (!maxSpeed) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid maxSpeed", speedZone);
                    } else if (!startTime) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid startTime", speedZone);
                    } else if (!endTime) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid endTime", speedZone);
                    } else {
                        durationString = moment.duration(endDate - startDate).humanize();
                        eventLabelComponent = (
                            <SpeedZoneLabel
                                speedLimit={speedLimit}
                                maxSpeed={maxSpeed}
                                startDate={startDate}
                                endDate={endDate}
                                unitOfMeasure={unitOfMeasure}
                            />
                        );
                        eventBadgeComponent = (
                            <SpeedZoneBadge
                                speedLimit={speedLimit}
                                maxSpeed={maxSpeed}
                                startDate={startDate}
                                endDate={endDate}
                                unitOfMeasure={unitOfMeasure}
                            />
                        );
                    }
                }
                break;
            case 'EVENT_IDLING_STARTED':
            case 'EVENT_IDLING_STOPPED':
            case 'EVENT_IDLING_MERGED':
                if (event.type === 'EVENT_IDLING_STARTED' && index > 0) {
                    break; // only show duration on a _LIVE_ EVENT_IDLING_STARTED
                    // IMPORTANT: no historical cards should have an EVENT_IDLING_STARTED at index 0 (i.e. without an EVENT_IDLING_STOPPED event)
                }
                var durationSeconds = event.duration;

                if (event.type === 'EVENT_IDLING_MERGED') {
                    eventLabelComponent = (
                        <IdlingBadge
                            durationSeconds={durationSeconds}
                            loc={this.state.tooltip}
                        />
                    );                
                } else if (event.type === 'EVENT_IDLING_STARTED') { // an unmerged event can be considering ongoing
                    if (!renderForDashboard) { // do not show duration on live dashboard idling started events
                        // use the threshold value for what triggered the event
                        durationSeconds = event.level;
                        // then add the difference between the event timestamp and now
                        const eventStartDate = event.ts.endsWith('Z') ? new Date(event.ts) : new Date(event.ts + 'Z');
                        const nowDate = new Date();
                        durationSeconds += (nowDate.getTime() - eventStartDate.getTime())/1000;
                    }
                    if (!durationSeconds && durationSeconds !== 0) {
                        console.error("EventScrollableList idling event duration not found", event);
                    } else {
                        eventLabelComponent = (
                            <IdlingBadge
                                durationSeconds={durationSeconds}
                                loc={this.state.tooltip}
                            />
                        );
                    }
                }
                break;
            case 'EVENT_KLOUD_DRIVER_DETECTED':
                var driverName = RavenUtil.getDriverNameForEvent(card, event);
                if (!driverName) {
                    driverName = strings.unknown_driver;
                }
                eventLabelComponent = (
                    <DriverBadge
                        driverName = {driverName}
                    />
                );
                break;
            case 'EVENT_ENGINE_OFF':
                eventLabelComponent = (
                    <LocationBadge
                        loc = {this.state.tooltip}
                    />
                );
                break;
            case 'EVENT_RAVEN_GEOFENCE_ENTER':
            case 'EVENT_RAVEN_GEOFENCE_EXIT':
                const geofenceId = event.eventParams && event.eventParams.EVENT_PARAM_GEOFENCE_ID;
                if(geofenceId) {
                    eventLabelComponent = (
                        <GeofenceBadge geofenceId={geofenceId}/>
                    );
                }
                break;
            case 'EVENT_POSSIBLE_IMPACT':
                const currentSpeedString = event.eventParams && event.eventParams.EVENT_PARAM_VEHICLE_SPEED_KPH;
                if (currentSpeedString) {
                    const currentSpeed = parseInt(currentSpeedString);
                    eventLabelComponent = (
                        <PossibleImpactBadge currentSpeed={currentSpeed} unitOfMeasure={unitOfMeasure} />
                    );
                }
                break;
            case 'EVENT_KLOUD_LIVE_STREAMING':
            case 'EVENT_KLOUD_HISTORICAL_STREAMING':
                eventLabelComponent = (
                    <StreamingBadge
                        level={event.level}
                        duration={event.duration}
                        media={event.media} // used for determining the media's creation date
                        currentLocale={currentLocale} // used for formatting that creation date onscreen
                    />
                );
                break;
            case 'EVENT_CAR_BATTERY_LOW':
                eventLabelComponent = (
                    <LowBatteryBadge />
                );
                break;
            default:
                break;
        }
        
        var timestamp = null;
        var tooltipTimestamp = null;
        if (moment(event.ts).format('MMM Do') === moment(referenceTime).format('MMM Do')) {
            timestamp = RavenUtil.toDate(event.ts).toLocaleTimeString(currentLocale, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});
            tooltipTimestamp = RavenUtil.toDate(event.ts).toLocaleTimeString(currentLocale, {year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric"});

        } else {
            timestamp = RavenUtil.toDate(event.ts).toLocaleString(currentLocale, {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});
            tooltipTimestamp = RavenUtil.toDate(event.ts).toLocaleString(currentLocale, {year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric"});
        }

        if (event.type === "EVENT_IDLING_STARTED") {
            // this event name requires duration information
            const durationSeconds = event.duration
            if (durationSeconds) {
                const mins = Math.round(durationSeconds/60);
                if (mins > 1) {
                    eventName = strings.formatString(strings.event_title_idling_started_duration_x_mins, mins);
                } else {
                    eventName = strings.event_title_idling_started_duration_1_min;
                }
            }
        }

        const tooltipText = tooltipTimestamp + "\n" + (this.state.tooltip ? this.state.tooltip : ''); // date+time and address

        // render classic events
        if (!renderFlexboxEvent) {
            return (
                <li
                    title={tooltipText}
                    className={className.join(' ')}
                    onClick={(e) => selectEvent(event)}
                >
                    <div className="event-icon">
                        <div className="timeline">
                            <div className="timeline-top"></div>
                            <div className="timeline-bottom"></div>
                        </div>
                        <EventIcon type={event.type} />
                    </div>
                    <div className="event-details">
                        <span className="event-title">
                            {eventName}
                            {eventLabelComponent}
                        </span>
                        <span className="event-timestamp">{timestamp}</span>
                        {this.props.renderForDashboard ?
                            <LegacyNonImmutableEventItemMediaIcon
                                event={event}
                                mediaRequestType={mediaRequestType}
                                allSupportedEvents={this.props.allSupportedEvents} // legacy (substitute) for redux store
                            />
                        :
                            <EventItemMediaIcon
                                ravenUuid={ravenUuid}
                                eventId={event.eventId} // requires eventId instead of event (event is from CardDetailsPanel state, eventId is used to lookup event in redux store)
                                mediaRequestType={mediaRequestType}
                            />
                        }
                    </div>
                </li>
            );    
        }

        // render new style events
        return (
            <li key={`${event.ts}${event.type}`} className={className.join(' ')} onClick={(e) => selectEvent(event)} >
                <div className="event-icon">
                    <div className="timeline">
                        <div className="timeline-top"></div>
                        <div className="timeline-bottom"></div>
                    </div>
                    <EventIcon type={event.type} />
                </div>
                <div className="event">
                    <div className="details">
                        <header>{eventName}</header>
                        <div className="description">{eventLabelComponent}</div>
                        <div className="time-duration">{timestamp}{durationString ? " • " + durationString : ""}</div>
                    </div>
                    <div className="features">
                        {eventBadgeComponent}
                        {this.props.renderForDashboard ?
                            <LegacyNonImmutableEventItemMediaIcon
                                event={event}
                                mediaRequestType={mediaRequestType}
                                allSupportedEvents={this.props.allSupportedEvents} // legacy (substitute) for redux store
                            />
                        :
                            <EventItemMediaIcon
                                ravenUuid={this.props.ravenUuid}
                                eventId={this.props.event.eventId} // requires eventId instead of event (event is from CardDetailsPanel state, eventId is used to lookup event in redux store)
                                mediaRequestType={this.props.mediaRequestType}
                            />
                        }
                    </div>
                </div>
            </li>
        );
    }
}
